const Style = {
    stack: 'space-y-4',
    hint: 'text-xs text-text-muted',
};

export default Style;
